/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query PhoneNumberoRoutePlanReadQuery($routePlanId: ID) {
  PhoneNumberoRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    message,
    status,
    Mcc {
      mcc,
      countryName,
      Mnc {
        mnc,
        network
      }
    },
    Mnc {
      id,
      mnc,
      network
    },
    PhoneNumberoRoute {
      displayName
    },
    PhoneNumberoDirectory {
      id,
      displayName
    },
    PhoneNumbero {
      id,
      phoneNumbero
    },
    PhoneNumberoVendorAccount {
      id,
      displayName
    }
    VendorAccount {
      id,
      displayName
    }
  }
}
`
